import { render } from "./CartPanel.vue?vue&type=template&id=8b2a675c&scoped=true"
import script from "./CartPanel.vue?vue&type=script&lang=js"
export * from "./CartPanel.vue?vue&type=script&lang=js"

import "./CartPanel.vue?vue&type=style&index=0&id=8b2a675c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2a675c"]])

export default __exports__